import React from 'react';
import PropTypes from 'prop-types';
import { withDefaultStyles } from '@bingads-webui-react/with-default-styles';
import { mergeI18n } from '@bingads-webui-campaign-react/i18n-merger';
import { HotelCenterReconReportGrid } from '@bingads-webui-campaign-react/hotel-center-recon-report-grid';
import { UiBlocker } from '@bingads-webui-react/ui-blocker';
import { iframeDownload } from '@bingads-webui/download-service';
import UploadInput from './upload/upload-input';
import UploadSummary from './upload/summary';
import { postCommitTask, pollExecutionResult } from './upload/api';
import errorMap from './upload/errorMap';
import getStyles from './style/index';

const hotelCenterI18n = window.globalLegacyI18n.get('@bingads-webui/i18n-amd-loader!campaignui/feature/hotel-center');

class HotelCenterUploadedReconReport extends React.PureComponent {
  constructor() {
    super();
    this.state = {
      uploading: false,
      loading: false,
      isUploadSccess: false,
      result: {},
      downloadPath: '',
      stage: 'preview',
      error: '',
    };
    this.grid = null;
  }

  downloadReports() {
    const { downloadPath } = this.state;
    iframeDownload(downloadPath);
  }

  handleUploadFinish(res) {
    const { i18n } = this.props;
    this.setState({
      loading: false,
      result: res,
      isUploadSccess: true,
      stage: 'preview',
      downloadPath: res.PreviewFileSasUrl,
      error: res.ErrorCount > 0 ?
        <React.Fragment>
          {res.Errors.map(error => <p key={error.Code}>{i18n.getString(errorMap[error.Code])}</p>)}
          <p>{i18n.getString(_TL_('Download the previewed report to see specific errors.'))}</p>
        </React.Fragment> : '',
    });
  }

  async handleApplyPreview() {
    this.setState({
      loading: true,
    });

    const { i18n, serverContext } = this.props;
    const {
      PreviewFileIdentifier, UploadedFileName, UploadDateTime, BookingCount,
    } = this.state.result;

    try {
      const previweTask = await postCommitTask({
        BlobName: PreviewFileIdentifier,
        fileName: UploadedFileName,
        UploadDateTime,
        BookingCount,
        IsProdEnv: serverContext.IsProdEnv,
      });
      const taskId = previweTask.TaskItemExecutions[0].Id;
      const commitResult = await pollExecutionResult({ id: taskId });
      this.setState({
        stage: 'commit',
        loading: false,
        result: commitResult,
      });
      this.grid.gridView.refresh(true);
    } catch (e) {
      this.setState({
        error: i18n.getString(_TL_('We\'ve encountered an error. Please try again or contact support.')),
      });
    }
  }

  handleDiscardPreview() {
    this.setState({
      error: '',
      result: {},
      isUploadSccess: false,
      uploading: false,
    });
  }

  handleCloseCommit() {
    this.setState({
      error: '',
      result: {},
      isUploadSccess: false,
      uploading: false,
    });
  }

  render() {
    const {
      classes, i18n, serverContext, perfMarker,
    } = this.props;
    const {
      isUploadSccess, uploading, loading, result, error, stage, downloadPath,
    } = this.state;
    const mergedI18n = mergeI18n(hotelCenterI18n, i18n);
    return (
      <React.Fragment>
        <section className={`${classes.marginContainer} intelligence-uploaded-recon-container`}>
          <UiBlocker
            blocking={loading}
            loadingText={i18n.getString(_TL_('Loading...'))}
            classes={{
              blockUiContainer: 'blocker',
              blockerIndicator: 'blocker-indicator',
            }}
          >
            <UploadInput
              i18n={mergedI18n}
              IsProdEnv={serverContext.IsProdEnv}
              publicPath={serverContext.PublicPath}
              uploading={uploading}
              onUploadStart={() => { this.setState({ uploading: true }); }}
              onUploadFinish={res => this.handleUploadFinish(res)}
              onError={err => this.setState({ error: err })}
            />
            {isUploadSccess && <UploadSummary
              i18n={mergedI18n}
              result={result}
              stage={stage}
              downloadPath={downloadPath}
              onApply={() => this.handleApplyPreview()}
              onDiscard={() => this.handleDiscardPreview()}
              onDownload={() => this.downloadReports()}
              onClose={() => this.handleCloseCommit()}
            />}
          </UiBlocker>
          { error &&
          <div className="col-sm-12 upload-err-info">
            <div className="alert alert-warning">
              <span className="alert-image" />
              <span>{error}</span>
            </div>
          </div> }
          <HotelCenterReconReportGrid
            i18n={mergedI18n}
            ref={this.uploadedReconGridRef}
            perfMarker={perfMarker}
            reportType="ReconciliationReport"
            onGridLoad={(grid) => {
              this.grid = grid;
            }}
          />
        </section>
      </React.Fragment>
    );
  }
}

HotelCenterUploadedReconReport.propTypes = {
  serverContext: PropTypes.shape({
    Token: PropTypes.string.isRequired,
  }).isRequired,
  classes: PropTypes.shape({}).isRequired,
  i18n: PropTypes.shape({}).isRequired,
  perfMarker: PropTypes.string.isRequired,
};

const Wrapped = withDefaultStyles(HotelCenterUploadedReconReport, getStyles);

export { Wrapped as HotelCenterUploadedReconReport };
